
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plaza/[id]",
      function () {
        return require("private-next-pages/plaza/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plaza/[id]"])
      });
    }
  